import React, { useState, useEffect } from 'react'
import styles from '../component-styles/calendar-summary-box.module.scss'
import { clientInstance } from '../store/sagas'
import { dateToYYYYMM } from '../helpers/dates'
import Row, { Slot } from './row'

interface Props {
  date?: Date
}

const history = new Map()

export default function SummaryBox({ date }: Props): React.ReactElement | null {
  const month = date ? dateToYYYYMM(date) : ''
  const [value, setValue] = useState('')

  useEffect((): void => {
    if (!date) return
    setValue('')
    const getFromApi = async (): Promise<void> => {
      const res = await clientInstance.getMonthlySummary(dateToYYYYMM(date))
      if (typeof res !== 'string') return
      setValue(res)
      history.set(date, res)
    }

    if (history.has(month)) {
      setValue(history.get(month))
      getFromApi()
    } else {
      getFromApi()
    }
    // eslint-disable-next-line
  }, [date])

  const saveChanges = (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
    const { value: val } = e.target as HTMLTextAreaElement
    if (!date) return
    if (value === '') {
      clientInstance.setMonthlySummary(dateToYYYYMM(date), val)
    } else {
      clientInstance.updateMonthlySummary(dateToYYYYMM(date), val)
    }
    setValue(val)
    history.set(month, val)
  }

  if (!date) return null

  return (
    <Row>
      <Slot>
        <div className={styles.container}>
          <h3>Outcomes, actions and learnings</h3>
          <textarea
            onChange={saveChanges}
            placeholder="Click here and start typing to add notes!"
            value={value}
          />
        </div>
      </Slot>
    </Row>
  )
}
